import { ArrowLeft } from '@/app/svgs/ArrowLeft';
import { publicEnv } from '@/lib/env';
import { NOT_FOUND_IMG } from '@/utils/constants';

interface ErrorProps {
  heading: string;
  subheading?: string;
}

export function Error({ heading, subheading }: ErrorProps) {
  return (
    <div className="min-h-dvh size-full flex justify-center items-center bg-white">
      <div className="flex flex-col gap-10 justify-center items-center max-w-2xl mx-4 md:mx-0">
        <img src={NOT_FOUND_IMG} alt="Not found illustration" />
        <div className="flex flex-col gap-3 items-center justify-center">
          <span className="font-semibold text-3xl leading-[38px] text-gray-900 text-center first-letter:uppercase">
            {heading}
          </span>
          {subheading ? (
            <span className="font-normal text-xl leading-[30px] text-gray-600 text-center">
              {subheading}
            </span>
          ) : null}
        </div>
        <a
          href={`https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}`}
          aria-label="Opens pickleball.com homepage"
          className="flex flex-row gap-3 items-center border border-solid border-gray-300 py-3 px-5 rounded-lg"
        >
          <ArrowLeft />
          <span className="font-semibold text-base leading-6 text-gray-700">
            Back to Pickleball.com
          </span>
        </a>
      </div>
    </div>
  );
}
